import {
  all, call, put, select, takeLatest, fork
} from "redux-saga/effects"

import * as actionTypes from "../../actions/types"
import * as actions from "../../actions"
import { getBaseUrl } from "../../reducers"
import * as requester from "../../requesters"

function* fetchCouponBySlug({ identifier }) {
  yield put(actions.couponRequestStart())
  const baseUrl = yield select(getBaseUrl)
  const { response, error, status, errorMessage } = yield call(requester.getCouponByIdentifier, baseUrl, identifier)
  yield (response) ? put(actions.couponRequestSuccess({ response, status, errorMessage })) : put(actions.couponRequestFailure(error))
}

function* fetchTopBrands() {
  const baseUrl = yield select(getBaseUrl)
  yield put(actions.topBrandsRequestStart())
  const { response, error } = yield call(requester.getTopBrands, baseUrl, { per_page: 8 })
  yield (response) ? put(actions.topBrandsRequestSuccess(response)) : put(actions.topBrandsRequestFailure(error))
}

function* fetchTopUpcomingSaleEvents() {
  const baseUrl = yield select(getBaseUrl)
  yield put(actions.topUpcomingSaleEventsRequestStart())
  const params = {
    upcoming: true
  }
  const { response, error } = yield call(requester.getTopSaleEvents, baseUrl, params)
  yield (response) ? put(actions.topUpcomingSaleEventsRequestSuccess(response)) : put(actions.topUpcomingSaleEventsRequestFailure(error))
}

function* fetchTopCurrentSaleEvents() {
  const baseUrl = yield select(getBaseUrl)
  yield put(actions.topCurrentSaleEventsRequestStart())
  const params = {
    current: true
  }
  const { response, error } = yield call(requester.getTopSaleEvents, baseUrl, params)
  yield (response) ? put(actions.topCurrentSaleEventsRequestSuccess(response)) : put(actions.topCurrentSaleEventsRequestFailure(error))
}

function* fetchTopCoupons() {
  const baseUrl = yield select(getBaseUrl)
  const { response, error } = yield call(requester.getTopCoupons, baseUrl, { per_page: 8 })
  yield (response) ? put(actions.topCouponsRequestSuccess(response)) : put(actions.topCouponsRequestFailure(error))
}

function* fetchTopDealHunters() {
  yield put(actions.topDealHuntersRequestStart())
  const baseUrl = yield select(getBaseUrl)
  const { response, error } = yield call(requester.getTopDealHunters, baseUrl, { per_page: 8 })
  yield (response) ? put(actions.topDealHuntersRequestSuccess(response)) : put(actions.topDealHuntersRequestFailure(error))
}

function* fetchData(data) {
  yield all([
    fork(fetchCouponBySlug, data),
    fork(fetchTopBrands, data),
    fork(fetchTopUpcomingSaleEvents, data),
    fork(fetchTopCurrentSaleEvents, data),
    fork(fetchTopDealHunters, data),
    fork(fetchTopCoupons, data)
  ])
}

function* watchCouponPageSaga() {
  yield takeLatest(actionTypes.LOAD_COUPON_PAGE, fetchData)
}

export {
  watchCouponPageSaga
}
